module.exports = __webpack_public_path__ + "static/media/RulesforRuleBreaking.4f5a4cd1.jpg";